import {Component, OnInit} from '@angular/core';
import {TermwebStatusService} from '@twpub/core/services';
import {HttpErrorResponse} from '@angular/common/http';
import {NgClass} from '@angular/common';

@Component({
  selector: 'pub-termweb-status-text',
  templateUrl: './termweb-status-text.component.html',
  styleUrls: ['./termweb-status-text.component.scss'],
  standalone: true,
  imports: [NgClass]
})
export class TermwebStatusTextComponent implements OnInit {
  termwebMessageType?: string;
  termwebMessage?: string;
  isLoading = true;

  constructor(private statusService: TermwebStatusService) {
  }

  ngOnInit(): void {
    this.getTermWebStatus();
  }

  private getTermWebStatus() {
    this.isLoading = true;
    this.statusService.getTermWebStatus().subscribe({
      next: status => {
        this.isLoading = false;
        if (status.ok) {
          this.termwebMessageType = 'success';
          this.termwebMessage = 'TermWeb connection successful';
        } else {
          this.termwebMessageType = 'danger';
          this.termwebMessage = 'TermWeb connection failed: ' + status.message;
        }
      },
      error: (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.termwebMessageType = 'danger';
        this.termwebMessage = error.message;
      }
    });
  }
}
